import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { client } from "~/clientInstance";
import { useUrlResolver } from "../useUrlResolver";
import { SpaceAwareNavigation } from "./SpaceAwareNavigation";
export function useSpaceAwareNavigation() {
    const navigate = useNavigate();
    const spaceId = client.spaceId ?? undefined;
    const urlResolver = useUrlResolver();
    return useMemo(() => new SpaceAwareNavigation(navigate, spaceId, urlResolver), [navigate, spaceId, urlResolver]);
}
